import { PageFragment } from "interfaces";
import CaretIcon from "public/svg/caret.svg";
import React, { useState } from "react";

import type { GridPageData } from "../wagtail/GridPage";

import styles from "./grid-list.module.scss";

export const GridList = ({ wagtail }: Pick<GridPageData, "wagtail">) => {
    const [listOpen, setListOpen] = useState(true);

    const buildPageListItem = (page: PageFragment, isRoot: boolean) => {
        const isCurrentPage = page.id === wagtail.id;
        return (
            <li key={page.id}>
                {isCurrentPage ? (
                    <>
                        <a
                            href={page.slug}
                            className={`${styles.currentLink} al-grid-rail__cat-nav-link al-grid-rail__cat-nav-link--current`}
                        >
                            {page.title}
                        </a>
                        <ul>
                            {wagtail.child_grids.map((page) =>
                                buildPageListItem(page, false),
                            )}
                        </ul>
                    </>
                ) : (
                    <a
                        href={page.slug}
                        className={
                            isRoot
                                ? `${styles.currentLink} al-grid-rail__cat-nav-link`
                                : "al-grid-rail__cat-nav-link"
                        }
                    >
                        {page.title}
                    </a>
                )}
            </li>
        );
    };

    return (
        <div className={styles.gridList}>
            <div
                className={styles.accordionButton}
                onClick={() => setListOpen(!listOpen)}
            >
                <span className={styles.browseBy}>Browse by</span>
                <CaretIcon className={styles.caretIcon} />
            </div>
            {listOpen && (
                <ul className={styles.links}>
                    <GridParent
                        wagtailID={wagtail.id}
                        parents={wagtail.ancestors.filter((page) => {
                            // don't show the homepage
                            if (page.slug === "/") return false;
                            // If this is a leaf grid (has no children) the page we're on will be listed with it's siblings
                            // so don't show it with the parents
                            if (
                                wagtail.child_grids.length === 0 &&
                                page.id === wagtail.id
                            )
                                return false;
                            return true;
                        })}
                        isRoot={true}
                    >
                        {wagtail.sibling_grids.length > 0 && (
                            <ul>
                                {wagtail.sibling_grids.map((page) =>
                                    buildPageListItem(page, false),
                                )}
                            </ul>
                        )}
                    </GridParent>
                </ul>
            )}
        </div>
    );
};

export function GridParent({
    parents,
    children,
    wagtailID,
    isRoot,
}: {
    parents: PageFragment[];
    children?: any;
    wagtailID: number;
    isRoot: boolean;
}) {
    const [current, ...rest] = parents;
    const onCurrentPage = current.id === wagtailID;

    return (
        <>
            <li>
                {!onCurrentPage && (
                    <a
                        href={current.slug}
                        className={`${styles.parentLink} al-grid-rail__cat-nav-link al-grid-rail__cat-nav-link--parent`}
                    >
                        {current.title}
                    </a>
                )}
                {rest.length > 0 ? (
                    <ul>
                        <GridParent
                            parents={rest}
                            wagtailID={wagtailID}
                            isRoot={false}
                        >
                            {children}
                        </GridParent>
                    </ul>
                ) : (
                    children
                )}
            </li>

            {!onCurrentPage &&
                !isRoot &&
                current.siblings.map((sibling, index) => (
                    <li key={index}>
                        <a
                            href={sibling.url}
                            className={`${styles.otherParentLink}  al-grid-rail__cat-nav-link al-grid-rail__cat-nav-link--parent`}
                        >
                            {sibling.title}
                        </a>
                    </li>
                ))}
        </>
    );
}
